import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  GetThicknessGauges,
  CreateThicknessGauge,
  UpdateThicknessGauge,
  DeleteThicknessGauge,
} from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { DEFAULT_STALE_TIME } from "../Constant/AppConstants";

export const thicknessGaugeQueryKeys = {
  all: ["thicknessGauges"] as const,
};

export const useThicknessGaugesQuery = (options?: ServiceQueryOptions) => {
  return useQuery({
    staleTime: DEFAULT_STALE_TIME,
    ...options,
    queryKey: thicknessGaugeQueryKeys.all,
    queryFn: async () => unwrapApiResponse(await GetThicknessGauges()),
  });
};

export const useCreateThicknessGaugeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof CreateThicknessGauge>[0]) =>
      CreateThicknessGauge(payload),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({
          queryKey: thicknessGaugeQueryKeys.all,
        });
      }
    },
  });
};

export const useUpdateThicknessGaugeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Parameters<typeof UpdateThicknessGauge>[0]) =>
      UpdateThicknessGauge(payload),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({
          queryKey: thicknessGaugeQueryKeys.all,
        });
      }
    },
  });
};

export const useDeleteThicknessGaugeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => DeleteThicknessGauge(id),
    onSuccess: (res) => {
      if (res?.success) {
        queryClient.invalidateQueries({
          queryKey: thicknessGaugeQueryKeys.all,
        });
      }
    },
  });
};
